import { eEstadoMaestro } from "../common/enumModel";
import { IFilterTipoReglaModel } from "../interfaces/tipo-regla/IFilterTipoReglaModel";

export class FilterTipoReglaModel implements IFilterTipoReglaModel {    
    idTipoRegla: number[];
    nombre: string;
    idEstado: eEstadoMaestro;
    page: number;
    pageSize: number;
    
    constructor(){
        this.idTipoRegla = new Array<number>();
        this.nombre = '';
        this.idEstado = eEstadoMaestro.ACTIVO;
        this.page = 1;
        this.pageSize = 30;
    }
}